/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/confirmIdeal.scss';

import {Loader, navigate} from '@dvrd/dvr-controls';

import IDate from '@dvrd/idate';

import React, {useContext, useEffect, useRef} from 'react';

import {useTranslation} from 'react-i18next';

import {createErrorMessage} from '../../../util/utils';

import {onConfirmCheckout} from '../../../util/events';

import Subscription from '../../../models/subscriptionModel';

import {AppContext} from '../../misc/appContext';

import Image from '../../misc/image';

import {showDialog} from '@dvrd/dvr-controls';

export default function ConfirmIdeal() {
    const {t} = useTranslation();
    const context = useContext(AppContext);
    const {account} = context.accountContext;
    const checkStarted = useRef<IDate>(IDate.now());
    const checkTimeout = useRef<number | null>(null);

    function confirm() {
        if (!account) return onError();
        Subscription.get(account.id, (subscription: Subscription | null, success: boolean) => {
            if (!subscription || !success || !subscription.hasPaymentMethod) {
                onError();
            } else {
                const {user} = context.userContext;
                if (user) {
                    user.subscription = subscription;
                    context.onChangeContext({user});
                }
                redirect(true);
            }
        });
    }

    function onError() {
        const now = IDate.now();
        if (now.absDiff(checkStarted.current, 'seconds') >= 300) {
            // 5 minutes have passed, stop checking.
            showDialog(
                createErrorMessage(
                    t('subscription.ideal.confirm.error', 'Het is niet gelukt de betaling te bevestigen.')
                ),
                t('subscription.ideal.confirm.errorTitle', 'Bevestigen mislukt')
            );
            redirect(false);
        } else {
            checkTimeout.current = window.setTimeout(confirm, 2500);
        }
    }

    function redirect(succeeded: boolean) {
        if (succeeded) onConfirmCheckout();
        navigate('/instellingen/abonnement');
    }

    useEffect(() => {
        confirm();

        return function () {
            if (checkTimeout.current !== null) window.clearTimeout(checkTimeout.current);
        };
    }, []);

    return (
        <div className='confirm-ideal'>
            <Image name='logo' className='logo' />
            <Loader active className='ideal-loader' disableBackground />
            <p className='comfirm-text'>
                {t(
                    'subscription.ideal.confirm.waitingText',
                    'De betaling wordt bevestigd, dit kan een aantal minuten duren.'
                )}
            </p>
        </div>
    );
}
